var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23.7931V30H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6377 25.648H8.30296C5.99786 25.648 4.77688 22.9441 6.3114 21.2377L11.3123 15.6773C11.6595 15.2914 11.6595 14.7086 11.3123 14.3227L6.3114 8.76204C4.77688 7.05565 5.99786 4.35175 8.30296 4.35175H15.6377C17.9428 4.35175 19.1638 7.05565 17.629 8.76204L12.6281 14.3227C12.2812 14.7086 12.2812 15.2914 12.6281 15.6773L17.629 21.2377C19.1638 22.9441 17.9428 25.648 15.6377 25.648ZM22.2053 19.6322L16.6837 13.4327C16.3965 13.1124 15.908 13.068 15.5667 13.3313L13.8385 14.6647L21.6969 5.96795C23.7612 3.64994 22.1023 -2.47955e-05 18.9846 -2.47955e-05H6.29985C0.883695 -2.47955e-05 -1.99835 6.34067 1.58793 10.3675L7.12596 16.5861C7.41542 16.8896 7.89039 16.9291 8.22507 16.6709L9.95321 15.3372L2.09632 24.0318C0.0317848 26.3498 1.69088 30 4.80858 30H17.4931C22.9095 30 25.7913 23.6591 22.2053 19.6322Z",
    fill: "#F1BF70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.0ceb9f201d6ec6e65c627594a630325f.svg";
export { ForwardRef as ReactComponent };